// Global storage keys
const KEY_LIST = "ai_convo_list";
const KEY_ACTIVE = "ai_active_convo_id";

// Helper to generate the unique storage key for each conversation
const keyConvo = (id) => `ai_convo_${id}`;

// Load / Save the list of conversations

export const loadConvoList = () =>
  JSON.parse(localStorage.getItem(KEY_LIST) || "[]");

export const saveConvoList = (list) =>
  localStorage.setItem(KEY_LIST, JSON.stringify(list));

// Load / Save the currently active conversation ID
export const loadActiveId = () =>
  localStorage.getItem(KEY_ACTIVE) || null;

export const saveActiveId = (id) => {
  if (id) localStorage.setItem(KEY_ACTIVE, id);
  else localStorage.removeItem(KEY_ACTIVE);
};

// ------------------------------------------
// Load / Save / Remove a specific conversation
// ------------------------------------------
export const loadConvo = (id) =>
  JSON.parse(localStorage.getItem(keyConvo(id)) || "null");

export const saveConvo = (convo) =>
  localStorage.setItem(keyConvo(convo.id), JSON.stringify(convo));

export const removeConvo = (id) =>
  localStorage.removeItem(keyConvo(id));
